import React, { Component } from 'react'
import { Link } from 'react-router-dom';

export default class Nav extends Component {
	constructor(context) {
		super(context);
	}

	render() {
		return (
			<div id="nav">
				<Link to="/24h">Accueil</Link>
				<Link to="/24h/About">À propos</Link>
			</div>
		);
	}
}